<!--
 * @FilePath: \nethallofficialaccounts\src\views\Bind\module\bottomSelection.vue
-->
<template>
    <div class="">
        <div class="content mgrA">
            <div v-for="(item,index) in dataValArr" :key="index">
                <p>{{item.year}}年账单</p>
                <ul>
                    <li 
                        v-for="(list, i) in item.yearMounth" 
                        :key="i" 
                        @click="selectSpan(index, i)"
                        :class="currentValue === `${index}${i}` ? 'currentSpan' : ''"
                    >
                        <span>{{list.name}}</span>
                        <div class="triangle" v-if="currentValue === `${index}${i}`">
                            <i><van-icon name="success" /></i>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: '',
    props: {
        dataValArr: {
            type: Array,
            require: true,
            default: () => {
                return [];
            }
        }
    },
    data() {
        return {
            currentValue: ''
        }
    },
    mounted() {

    },
    methods: {
        selectSpan(index, i) {
            this.currentValue = `${index}${i}`
            this.$emit('getSelectValue', this.dataValArr[index].year, this.dataValArr[index].yearMounth[i].name)
        }
    }
}
</script>

<style lang="less" scoped>
.content {
    padding-top: 5px;
    padding-bottom: 10px;
    p {
        margin: 0px;
        padding-top: 10px;
    }
    // li标签
    ul {
        li {
            width: calc(100% / 3 - 17px);
            display: inline-block;
            text-align: center;
            // border: 1px solid#F5F5F5;
            background-color: #F5F5F5;
            border-radius: 3px;
            margin-right: 15px;
            margin-top: 15px;
            position: relative;
            overflow: hidden;
            span {
                display: inline-block;
                height: 32px;
                line-height: 32px;
                font-family: PingFangSC-Medium;
                font-size: 14px;
                color: #333333;
                text-align: center;
            }
            // 选中样式
            .triangle {
                width: 30px;
                height: 30px;
                background: #1677FF;
                position: absolute;
                bottom: -15px;
                right: -15px;
                transform: rotate(45deg);
                i {
                    position: absolute;
                    bottom: 5px;
                    right: 5px;
                    display: block;
                    width: 18px;
                    text-align: center;
                    color: #ffffff;
                    transform: rotate(-25deg);
                }
            }
            .triangle::after {
                display: inline-block;
                content: '';
                width: 30px;
                height: 35px;
                background: #ffffff;
                transform: rotate(-45deg);
                position: absolute;
                bottom: 18px;
                right: 0px;
                z-index: 20;
            }
        }
        li:nth-child(3n) {
            margin-right: 0px;
        }
        // 选中的样式
        .currentSpan {
            color: #1677FF;
            background: #E7F1FF;
        }
    }
}
.mgrA {
    margin-left: 16px;
}
</style>